import { apiGet, API_URI } from 'api';

const sortbins = {
    getAll: async (projectId: number) => {
        const data = apiGet(`${API_URI}/api/subfolder/getall?clientId=` + projectId);
        return data;
    },
    get: async (reactionListId: number) => {
        const data = apiGet(`${API_URI}/api/wordbins/get?id=` + reactionListId);
        return data;
    },
    getWordBinGroups: async (clientId: number) => {
        const data = apiGet(`${API_URI}/api/wordbins/group/getall?clientId=` + clientId);
        return data;
    }
}

export default sortbins;